import { Layout, Menu } from "antd";
import { Link } from "react-router-dom";

import styles from "./Sidebar.module.scss";
import {
  BellOutlined,
  ControlOutlined,
  NotificationOutlined,
  DollarOutlined,
  SettingOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UserOutlined,
  StopOutlined,
  InfoCircleOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

import { ROUTES } from "@routes/routes";

const menu = [
  {
    key: "users",
    icon: <UserOutlined />,
    label: <Link to={ROUTES.USERS}>Users</Link>,
    pathname: ROUTES.USERS,
  },
  {
    key: "players",
    icon: <TeamOutlined />,
    label: <Link to={ROUTES.PLAYERS}>Players</Link>,
    pathname: ROUTES.PLAYERS,
  },
  {
    key: "notifications",
    icon: <BellOutlined />,
    label: <Link to={ROUTES.NOTIFICATIONS}>Notifications</Link>,
    pathname: ROUTES.NOTIFICATIONS,
  },
  {
    key: "plans",
    icon: <UnorderedListOutlined />,
    label: <Link to={ROUTES.PLANS}>Plans</Link>,
    pathname: ROUTES.PLANS,
  },
  {
    key: "transactions",
    icon: <DollarOutlined />,
    label: <Link to={ROUTES.TRANSACTIONS}>Transactions</Link>,
    pathname: ROUTES.TRANSACTIONS,
  },
  {
    key: "popups",
    icon: <NotificationOutlined />,
    label: <Link to={ROUTES.POPUPS}>Popups</Link>,
    pathname: ROUTES.POPUPS,
  },
  {
    key: "store_banners",
    icon: <InfoCircleOutlined />,
    label: <Link to={ROUTES.STORE_BANNERS}>Store Banners</Link>,
    pathname: ROUTES.STORE_BANNERS,
  },
  {
    key: "tiers",
    icon: <TrophyOutlined />,
    label: <Link to={ROUTES.TIERS}>Tiers</Link>,
    pathname: ROUTES.TIERS,
  },
  {
    key: "baselines",
    icon: <UnorderedListOutlined />,
    label: <Link to={ROUTES.BASELINES}>Global Baselines</Link>,
    pathname: ROUTES.BASELINES,
  },

  {
    key: "restricted_usernames",

    icon: <StopOutlined />,
    label: <Link to={ROUTES.RESTRICTED_USERNAMES}>Restricted Usernames</Link>,
    pathname: ROUTES.RESTRICTED_USERNAMES,
  },
  {
    key: "configurations",
    icon: <ControlOutlined />,
    label: <Link to={ROUTES.CONFIGURATIONS}>Configurations</Link>,
    pathname: ROUTES.CONFIGURATIONS,
  },
  {
    key: "settings",
    icon: <SettingOutlined />,
    label: <Link to={ROUTES.SETTINGS}>Settings</Link>,
    pathname: ROUTES.SETTINGS,
  },
];

const Sidebar = () => {
  return (
    <Layout.Sider width={270}>
      <Menu mode="inline" className={styles.menu} items={menu} />
    </Layout.Sider>
  );
};

export default Sidebar;
